export const SUPPORT_EMAIL = (
  process.env.REACT_APP_SUPPORT_EMAIL || 'sahel.mastoureshgh@gmail.com'
).trim();

export const supportMailto = (subject = '') => (
  `mailto:${SUPPORT_EMAIL}${subject ? `?subject=${encodeURIComponent(subject)}` : ''}`
);
